import React from "react";

const GraphicDesignHero = () => {
  return (
    <section className="relative py-20 w-full flex items-center justify-center bg-slate-950 text-white overflow-hidden">
      <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-blue-500 rounded-full blur-[120px] opacity-40"></div>
      <div className="absolute bottom-[-10%] left-[-5%] w-[600px] h-[600px] bg-blue-600 rounded-full blur-[120px] opacity-40"></div>

      {/* ---  Main COntent --- */}
      <div className="relative z-10 text-center px-6 max-w-4xl">
        {/* Label of banner */}
        <span className="inline-block py-1 px-3 rounded-full bg-white/10 border border-white/20 text-white text-xs font-bold uppercase tracking-widest mb-6 backdrop-blur-sm">
          Creative Design Agency
        </span>

        {/* Banner  */}
        <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight tracking-tight">
          Where Ideas Become <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-600 to-blue-400">
            Visual Reality
          </span>
        </h1>

        {/* Description */}
        <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          We craft pixel-perfect designs, robust branding, and memorable user
          experiences that define your digital presence.
        </p>
      </div>
    </section>
  );
};

export default GraphicDesignHero;
